import './App.css';
import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Icon,
  Segment,
  Sidebar,
  Label
} from 'semantic-ui-react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Map from './components/Map';
import RoutingMenu from './components/RoutingMenu';
import Footer from './components/Footer';
import Kontakt from './components/Kontakt';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';

import { SET_SIDEBAR_VISIBILITY } from './actions/types';
import { setSidebarVisibility } from './actions/interactionActions';

class App extends React.Component {
  render() {

    return (
      <Router>
        <div>
          <Switch>
            <Route path='/' exact>
              <div style={{ filter: this.props.brightnessValue }}>
                {!this.props.visible ? <Button id='sidebar-open-btn' icon='arrow right' onClick={() => { this.props.setSidebarVisibility(SET_SIDEBAR_VISIBILITY) }} style={{ zIndex: 1, position: 'absolute' }}>
                  <Icon name='right chevron' id='sidebar-open-btn-icon' />
                </Button> : null}
                <Sidebar.Pushable as={Segment} style={{ overflow: 'hidden', margin: 0, padding: 0, borderRadius: 0, border: 'none' }}>

                  <RoutingMenu visibility={this.props.visible} style={{height: '96vh'}}>
                    <Label as='a' color='orange' ribbon='right'>
                      Specs
            </Label>
                  </RoutingMenu>
                  <Sidebar.Pusher>
                    <Map />
                  </Sidebar.Pusher>
                  <Footer />
                </Sidebar.Pushable>
              </div>
            </Route>

            <Route path='/kontakt' exact>
              <Kontakt />
            </Route>

            <Route path='/impressum' exact>
              <Impressum />
            </Route>

            <Route path='/data-policy' exact>
              <Datenschutz />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  visible: state.posts.sideBarVisible,
  brightnessValue: state.screens.brightnessValue,
});

export default connect(mapStateToProps, { setSidebarVisibility })(App);
